import { MainAttachments, type MainAttachmentsSkin } from '@/deskUiSkeletons/Page/MainAttachments'

const forumMainAttachmentsSkin: MainAttachmentsSkin = {
  empty: 'flex min-h-[280px] items-center justify-center border border-[#006699] bg-[#eef3f8] font-[Verdana,Arial,Helvetica,sans-serif] text-[11px] text-black',
  root: 'flex min-h-0 w-full flex-1 flex-col gap-2 border border-[#006699] bg-white p-2 font-[Verdana,Arial,Helvetica,sans-serif] text-[11px] text-black',
  header: 'flex items-center justify-between bg-[#006699] px-2 py-1 text-white',
  title: 'font-bold',
  count: 'bg-white px-1.5 py-0.5 text-[10px] font-bold text-[#006699]',
  body: 'grid min-h-0 flex-1 grid-cols-[minmax(0,1fr)_180px] gap-2 max-[720px]:grid-cols-1',
  preview: 'flex min-h-[300px] items-center justify-center overflow-hidden border border-[#006699] bg-[#dfe6ef] p-2',
  image: 'max-h-[75vh] max-w-full object-contain',
  side: 'flex min-h-0 flex-col gap-2',
  meta: 'border border-[#006699] bg-[#eef3f8] p-2',
  metaTitle: 'break-words font-bold',
  metaDescription: 'mt-1 break-words text-[10px] leading-4',
  nav: 'flex gap-1',
  button: 'flex-1 border border-[#003f63] bg-[#006699] px-2 py-1 text-[10px] font-bold text-white',
  thumbs: 'grid max-h-[calc(75vh-120px)] grid-cols-2 gap-1 overflow-auto',
  thumb: 'border p-1',
  thumbSelected: 'border-[#ff6600] bg-[#ffffcc]',
  thumbUnselected: 'border-[#006699] bg-[#eef3f8]',
  thumbImage: 'h-16 w-full object-cover',
}

export function ForumMainAttachments() {
  return <MainAttachments skin={forumMainAttachmentsSkin} />
}
